import { Box, Typography } from "@mui/material";

import styles from "./styles";

const TypingLoader = ({ title = "Typing" }: { title?: string }) => {
  return (
    <Box display="flex" alignItems="center">
      {title && (
        <Typography sx={styles.text} component="span">
          {title}
        </Typography>
      )}
      <Box sx={styles.dots}>
        <Box sx={[styles.dot, styles.dot1]}></Box>
        <Box sx={[styles.dot, styles.dot2]}></Box>
        <Box sx={[styles.dot, styles.dot3]}></Box>
      </Box>
    </Box>
  );
};

export default TypingLoader;
